import React from 'react';
import { observer } from 'mobx-react';
import { ListWrapper } from '../ListWrapper';
import { useInvoicesFilterParams } from '../../hooks';
import { cleanInvoicesRelationSelectAndStore, getInvoicesRelationSelect } from '../../middleware';
import { Catcher } from '../Catcher';
import { InvoicesTableList } from './Components';

export const InvoicesList: React.FC = observer(() => {
    const filterParams = useInvoicesFilterParams();

    return (
        <Catcher>
            <ListWrapper
                cleanStore={cleanInvoicesRelationSelectAndStore}
                filterParams={filterParams}
                getRelationSelect={getInvoicesRelationSelect}
            >
                <InvoicesTableList />
            </ListWrapper>
        </Catcher>
    );
});
